import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const path = location.pathname;

  const adminToken = Cookies.get("admin_token");
  const instToken = Cookies.get("institution_token");
  const teacherToken = Cookies.get("teacher_token");

  if (path.startsWith("/admin")) {
    if (!adminToken) {
      return <Navigate to="/admin/login" replace />;
    }
  } else if (path.startsWith("/teacher")) {
    if (!teacherToken) {
      return <Navigate to="/" replace />;
    }
  } else if (path.startsWith("/institution")) {
    if (!instToken) {
      return <Navigate to="/" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
